import script from "./SeasonsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeasonsSection.vue?vue&type=script&setup=true&lang=ts"

import "./SeasonsSection.vue?vue&type=style&index=0&id=667d6e00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667d6e00"]])

export default __exports__